import { render, staticRenderFns } from "./often-rules.vue?vue&type=template&id=f6860e94&scoped=true&"
import script from "./often-rules.vue?vue&type=script&lang=js&"
export * from "./often-rules.vue?vue&type=script&lang=js&"
import style0 from "./often-rules.vue?vue&type=style&index=0&id=f6860e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6860e94",
  null
  
)

export default component.exports